/**
 * Copyright 2017 Control4 Corporation. All rights reserved.
 * Control4 Confidential and Proprietary Information.
 */

import { Routes, RouterModule, CanActivate } from '@angular/router';
import { NgModule } from '@angular/core';

import { QUICKSTART_ACTIONS_NOTIFICATIONS_ROUTES } from './quickstart-notifications/notifications.routes';
import { QUICKSTART_TRIGGERS_BUTTONS_ROUTES } from './quickstart-buttons/buttons.routes';
import { QUICKSTART_ACTIONS_LIGHTS_ROUTES } from './quickstart-lights/quickstart-lights.routes';
import { SCHEDULER_QUICKSTART_TRIGGER_ROUTES } from './quickstart-schedule/schedule-quickstart.routes';
import { QUICKSTART_TRIGGERS_SIMPLE_ROUTES, QUICKSTART_ACTIONS_SIMPLE_ROUTES } from './quickstart-simple/quickstart-simple.routes';
import { QUICKSTART_TRIGGERS_ROOMS_ROUTES, QUICKSTART_ACTIONS_ROOMS_ROUTES } from './quickstart-rooms/quickstart-rooms.routes';
import { QUICKSTART_ACTIONS_MEDIA_ROUTES } from './quickstart-media/quickstart-media.routes';
import { QUICKSTART_ACTIONS_THERMOSTAT_ROUTES } from './quickstart-thermostats/quickstart-thermostats.routes';

import { TriggersComponent } from './triggers/triggers.component';
import { EditComponent } from './edit/edit.component';
import { ViewComponent } from './view/view.component';
import { ListByTypeComponent } from './list-by-type/list-by-type.component';
import { ListByRoomComponent } from './list-by-room/list-by-room.component';
import { ListByNameComponent } from './list-by-name/list-by-name.component';
import { QuickstartsComponent } from './quickstarts.component';
import { SelectEventTypeComponent } from './select-event-type/select-event-type.component';
import { StartComponent } from './start/start.component';
import { EventsComponent } from './events/events.component';
import { SelectActionComponent } from './select-action/select-action.component';
import { TodayComponent } from './today/today.component';
import { EventComponent } from './event/event.component';
import { AddComponent } from './add/add.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { IntroductionComponent } from './introduction/introduction.component';
import { SkipWelcomeGuard } from './guards/skip-welcome.guard';
import { ListByDateComponent } from './quickstart-schedule/list-by-date/list-by-date.component';

const QUICKSTART_ACTION_ROUTES: Routes = [
  ...QUICKSTART_ACTIONS_NOTIFICATIONS_ROUTES,
  ...QUICKSTART_ACTIONS_LIGHTS_ROUTES,
  ...QUICKSTART_ACTIONS_MEDIA_ROUTES,
  ...QUICKSTART_ACTIONS_THERMOSTAT_ROUTES,
  ...QUICKSTART_ACTIONS_ROOMS_ROUTES,
  ...QUICKSTART_ACTIONS_SIMPLE_ROUTES
];

export const QUICKSTART_PROGRAMMING_ROUTES: Routes = [{
  path: '', redirectTo: 'when-then', pathMatch: 'full'
}, {
  path: 'when-then', component: QuickstartsComponent, children: [{
    path: '', redirectTo: 'start', pathMatch: 'full'
  }, {
    path: 'welcome', component: WelcomeComponent
  }, {
    path: 'intro', component: IntroductionComponent
  }, {
    path: 'start', component: StartComponent,
    canActivate: [SkipWelcomeGuard], canActivateChild: [SkipWelcomeGuard],
    children: [{
      path: '', redirectTo: 'create', pathMatch: 'full'
    }, {
      path: 'create', component: SelectEventTypeComponent
    },
    {
      path: 'edit', component: EventsComponent
    }
    ]
  }, {
    path: 'triggers', component: TriggersComponent, children: [
      ...SCHEDULER_QUICKSTART_TRIGGER_ROUTES,
      ...QUICKSTART_TRIGGERS_BUTTONS_ROUTES,
      ...QUICKSTART_TRIGGERS_ROOMS_ROUTES,
      ...QUICKSTART_TRIGGERS_SIMPLE_ROUTES,
    ]
  }, {
    path: 'device/:deviceId/event/:eventId',
    component: EventComponent,
    children: [{
      path: '', redirectTo: 'edit', pathMatch: 'full'
      // }, {
      //   path: 'view', component: ViewComponent
    }, {
      path: 'edit', component: EditComponent
    }, {
      path: 'add', component: AddComponent, children: [{
        path: '', redirectTo: 'select', pathMatch: 'full'
      }, {
        path: 'select', component: SelectActionComponent
      },
      ...QUICKSTART_ACTION_ROUTES
      ]
    }]
  }]
}]



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstarts.routes.ts